import * as React from "react";
const SvgSlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 7, height: 16, viewBox: "0 0 7 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 5.94226, y1: 0.17101, x2: 0.469936, y2: 15.2061, stroke: "currentColor" }));
export default SvgSlash;
